export default {
  methods: {
    getIconFile (formatfile) {
      const format = formatfile ? formatfile.split('/.')[1] : ''
      let currentIcon = ''
      switch (format.toLowerCase()) {
        case 'doc':
          currentIcon = require('@/assets/image/icon/file-format-symbol-doc.svg')
          break
        case 'docx':
          currentIcon = require('@/assets/image/icon/file-format-symbol-docx.svg')
          break
        case 'exe':
          currentIcon = require('@/assets/image/icon/file-format-symbol-exe.svg')
          break
        case 'gif':
          currentIcon = require('@/assets/image/icon/file-format-symbol-gif.svg')
          break
        case 'jpeg':
          currentIcon = require('@/assets/image/icon/file-format-symbol-jpeg.svg')
          break
        case 'jpg':
          currentIcon = require('@/assets/image/icon/file-format-symbol-jpg.svg')
          break
        case 'pdf':
          currentIcon = require('@/assets/image/icon/file-format-symbol-pdf.svg')
          break
        case 'png':
          currentIcon = require('@/assets/image/icon/file-format-symbol-png.svg')
          break
        case 'ppt':
          currentIcon = require('@/assets/image/icon/file-format-symbol-ppt.svg')
          break
        case 'pptx':
          currentIcon = require('@/assets/image/icon/file-format-symbol-pptx.svg')
          break
        case 'rar':
          currentIcon = require('@/assets/image/icon/file-format-symbol-rar.svg')
          break
        case 'xls':
          currentIcon = require('@/assets/image/icon/file-format-symbol-xls.svg')
          break
        case 'xlsx':
          currentIcon = require('@/assets/image/icon/file-format-symbol-xlsx.svg')
          break
        case 'zip':
          currentIcon = require('@/assets/image/icon/file-format-symbol-zip.svg')
          break
        default:
          break
      }
      return currentIcon
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getters/file-extention.js